import './RadioButton.css';
import React, { ChangeEventHandler } from 'react';
import { cx } from '#/Scripts/utilities/cx';
import { LabelFor } from '#sign-up/components/shared/LabelFor';

type RadioButtonProps = React.InputHTMLAttributes<HTMLInputElement> & {
  checked?: boolean;
  name: string;
  id?: string;
  value?: string;
  label: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ checked = false, name, id, value, label, onChange, ...props }: RadioButtonProps, ref) => {
    return (
      <div className={cx('radio-input', checked && 'selected')}>
        <input
          id={id || name}
          ref={ref}
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          title={label}
          {...props}
        />
        <LabelFor name={name} label={label} />
      </div>
    );
  }
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
